<template>
  <div class="ency-detail">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <i class="el-icon-s-home"></i>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/encyclopedias' }">珠宝百科</el-breadcrumb-item>
      <el-breadcrumb-item>{{detail.type==1?'珠宝讲堂':'最新活动'}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="wrap">
      <h2>{{detail.title}}</h2>
      <p>
        <i class="el-icon-date"></i>
        {{detail.create_time}}
      </p>
      <div class="rich" v-html="detail.content"></div>
    </div>
    <p class="btn">
      <span @click="to(1)">上一篇：{{detail.page_up?detail.page_up.title: '无'}}</span>
      <span class="button" @click="$router.back()">返回</span>
      <span @click="to(2)">下一篇：{{detail.page_down?detail.page_down.title : '无'}}</span>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {}
    };
  },
  beforeRouteUpdate(t, f, n) {
    n();
    setTimeout(() => {
      location.reload();
    }, 100);
  },
  created() {
    this.axios.post("news/details", { id: this.$route.query.id }).then(r => {
      console.log(r);
      this.detail = { ...r };
      this.detail.create_time = this.formatteTime(this.detail.create_time);
    });
  },
  methods: {
    to(e) {
      let id;
      if (e == 1) {
        id = this.detail.page_up
          ? this.detail.page_up.id
          : this.$route.query.id;
      } else {
        id = this.detail.page_down
          ? this.detail.page_down.id
          : this.$route.query.id;
      }
      this.$router.push({ path: this.$route.path, query: { id } });
    }
  }
};
</script>

<style lang="less" scoped>
.ency-detail {
  font-family: FZShuSong-Z01T;
  padding: 0.61rem 3.6rem;
  .el-breadcrumb {
    margin-bottom: 0.22rem;
  }
  .wrap {
    width: 100%;
    padding: 0.47rem 0.4rem;
    background: #ffffff;
    h2 {
      font-size: 0.24rem;
      font-family: FZShuSong-Z01T;
      color: #333333;
      text-align: center;
      font-weight: 400;
      margin-bottom: 0.28rem;
    }
    p {
      text-align: center;
      font-size: 0.14rem;
      font-family: "FZShuSong-Z01T";
      font-weight: 400;
      padding-bottom: 0.2rem;
      border-bottom: 1px solid rgba(33, 50, 119, 1);
      margin-bottom: 0.2rem;
      i {
        color: rgba(127, 109, 70, 1);
        font-size: 0.2rem;
        margin-right: 0.05rem;
        vertical-align: middle;
      }
    }
  }
}
.btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    cursor: pointer;
    max-width: 30%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  .button {
    width: 120px;
    height: 40px;
    background: rgba(127, 109, 70, 1);
    opacity: 1;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    color: white;
    font-size: 14px;
    font-family: FZShuSong-Z01T;
    font-weight: 400;
  }
  .button:hover {
    opacity: 0.78;
  }
}
@media (max-width: 767px) {
  .ency-detail {
    padding: 20px 10px;
    .wrap {
      padding: 30px 0;
      h2 {
        font-size: 20px;
      }
      p {
        font-size: 14px;
        i {
          font-size: 20px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ency-detail.vue